(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hush-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeHushReviews = (root = document) => {
    root.querySelectorAll('[data-hush-reviews]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-review-track]');
      const cards = Array.from(carousel.querySelectorAll('[data-review-card]'));
      const dots = Array.from(carousel.querySelectorAll('[data-review-dot]'));
      const previous = carousel.querySelector('[data-review-previous]');
      const next = carousel.querySelector('[data-review-next]');
      if (!track || cards.length < 2) return;

      const activeIndex = () => {
        const left = track.scrollLeft;
        return cards.reduce((closest, card, index) => {
          const closestDistance = Math.abs(cards[closest].offsetLeft - left);
          const distance = Math.abs(card.offsetLeft - left);
          return distance < closestDistance ? index : closest;
        }, 0);
      };

      const updateDots = () => {
        const active = activeIndex();
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === active);
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const goTo = (index) => {
        const target = (index + cards.length) % cards.length;
        track.scrollTo({ left: cards[target].offsetLeft, behavior: 'smooth' });
      };

      let frame;
      previous?.addEventListener('click', () => goTo(activeIndex() - 1));
      next?.addEventListener('click', () => goTo(activeIndex() + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateDots);
      }, { passive: true });
      updateDots();
    });
  };

  initializeHushReviews();
  document.addEventListener('shopify:section:load', (event) => initializeHushReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nod-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.getAttribute('data-nod-init') === '1') return;
    root.setAttribute('data-nod-init', '1');

    var track = root.querySelector('[data-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    function setOn(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', i === j); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
    }
    function go(i) {
      if (!track) return;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      setOn(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          setOn(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
        });
      }, { passive: true });
    }
    setOn(0);

    var radios = Array.prototype.slice.call(root.querySelectorAll('.nod-offer input'));
    var vid = root.getAttribute('data-variant');
    var atcs = Array.prototype.slice.call(root.querySelectorAll('[data-atc]'));
    var stickyLabel = root.querySelector('[data-sticky-label]');
    function update() {
      var r = null;
      radios.forEach(function (x) {
        x.closest('.nod-offer').classList.toggle('is-on', x.checked);
        if (x.checked) r = x;
      });
      if (!r) return;
      vid = r.value;
      atcs.forEach(function (b) {
        if (b.getAttribute('data-show-price') === 'true' && !b.disabled) b.textContent = b.getAttribute('data-base') + ' — ' + r.getAttribute('data-price');
      });
      if (stickyLabel) stickyLabel.textContent = r.getAttribute('data-label') + ' — ' + r.getAttribute('data-price');
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();

    function add(btn) {
      if (btn.disabled || !vid) return;
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = root.getAttribute('data-adding') || 'Adding...';
      fetch(root.getAttribute('data-add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      })
        .then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); })
        .then(function () {
          window.location.href = root.getAttribute('data-redirect') === 'checkout' ? '/checkout' : root.getAttribute('data-cart');
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = orig;
          window.alert(root.getAttribute('data-err') || 'Could not add to cart. Please try again.');
        });
    }
    root.querySelectorAll('[data-atc],[data-atc-sticky]').forEach(function (b) {
      b.addEventListener('click', function () { add(b); });
    });

    var sticky = root.querySelector('[data-sticky]');
    if (sticky && atcs[0] && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atcs[0]);
    }
  }
  function scan() {
    document.querySelectorAll('[data-nod-hero]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest ? ev.target.closest('a[href="#nod-buy"]') : null;
    if (!a) return;
    var t = document.getElementById('nod-buy');
    if (!t) return;
    ev.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
